import { Box, Chip, FormControlLabel, Stack, Switch, Typography } from '@mui/material';
import { useState } from 'react';
import { API } from '../../lib/api';

export default function OpportunityCompletionStatus({ project, pid, setFeedback, setLogs, setProject }) {
    const [saving, setSaving] = useState(false);
    const total = (project?.lines || []).reduce((sum, line) => sum + (Number(line.amount) || 0), 0);
    const changeArchived = async (event) => {
        const archived = event.target.checked;
        setSaving(true);
        try {
            const response = await API.Opportunities.UpdateSingle(pid, { archived });
            if (response.status !== 200) throw new Error(response.data?.message || 'Unable to update opportunity.');
            setProject(previous => ({ ...previous, archived }));
            setFeedback({ open: true, type: 'success', message: archived ? 'Opportunity archived.' : 'Opportunity restored.' });
            setLogs(await API.OpportunityLogs.FetchByOppId(pid));
        } catch (error) {
            setFeedback({ open: true, type: 'error', message: error.message || 'Unable to update opportunity.' });
        } finally { setSaving(false); }
    };
    return <Box className="card" sx={{ p: 3 }}>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems={{ sm: 'center' }} justifyContent="space-between">
            <Box>
                <Typography variant="body2" color="text.secondary">Revenue total</Typography>
                <Typography variant="h5" color="success.main">{new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(total)}</Typography>
            </Box>
            <Stack direction="row" alignItems="center" spacing={2} flexWrap="wrap">
                <Chip variant="outlined" color={project?.allowInForecast ? 'success' : 'error'} label={project?.allowInForecast ? 'Included in forecast' : 'Not in forecast'} />
                <FormControlLabel label="Archive opportunity" control={<Switch checked={Boolean(project?.archived)} disabled={saving} onChange={changeArchived} />} />
            </Stack>
        </Stack>
    </Box>;
}
